import axios from "axios";

// const baseURL = "http://127.0.0.1:8000/api"

const baseURL = "https://order.iaecxmu.cn/api"

const instance = axios.create({
    timeout: 10000,
    withCredentials: false
});

/**
 * get 请求
 * @param {string} url
 * @param {object} config
 */
instance._get = async function (url, config) {
    const requestUrl = baseURL + url;
    try {
        const {
            data
        } = await this.get(requestUrl, config);
        return data;
    } catch (error) {
        error.requestUrl = requestUrl;
        throw error;
    }
};

/**
 * post 请求
 * @param {string} url
 * @param {object} body
 * @param {object} config
 */
instance._post = async function (url, body, config) {
    const requestUrl = baseURL + url;
    try {
        const {
            data
        } = await this.post(requestUrl, body, config);
        return data;
    } catch (error) {
        error.requestUrl = requestUrl;
        throw error;
    }
};

export default instance;
